// extracted by mini-css-extract-plugin
export default {"musicNote":"MusicNote_musicNote__NiJq9","wrong":"MusicNote_wrong__00+PB"};